import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { REPORTING_API_REQUEST } from 'ag-common-svc/public-api';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Reporting API errors reach their callers intact: the shared report pages read the status
    // to tell "no data yet" (404) from "no access" (403), which a bare message string loses.
    if (request.context.get(REPORTING_API_REQUEST)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        // Do not reload on 401. A reload does not clear the Firebase session, so any request that
        // keeps returning 401 (expired token, API pointed at another Firebase project) re-fires on
        // the next boot and the page reloads forever. Signed-out users are handled by the guards.
        const error = err?.error?.message || err?.statusText || err?.message;
        return throwError(() => error);
      }),
    );
  }
}
